import { render, staticRenderFns } from "./Desc.vue?vue&type=template&id=7ab3d2c2&scoped=true&"
import script from "./Desc.vue?vue&type=script&lang=js&"
export * from "./Desc.vue?vue&type=script&lang=js&"
import style0 from "./Desc.vue?vue&type=style&index=0&id=7ab3d2c2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab3d2c2",
  null
  
)

export default component.exports